export default "__VITE_PUBLIC_ASSET__1cf3b9eb__"